import React from 'react';

import { Table, TableHeader, TableColumn, TableRow, Loader } from '@td/ui';
import { useNpCoordination } from '../context/NpCoordinationContext';
import EditModal from './EditModal';
import ProviderCell from './ProviderCell';
import { convertStateCdToStateNm } from '../utils';

const NpCoordinationItemsTable = () => {
  const { npCoordinationItems, itemsLoading } = useNpCoordination();

  return (
    <Table>
      <TableHeader>
        <TableColumn>Nurse Practitioner</TableColumn>
        <TableColumn>Licensed State</TableColumn>
        <TableColumn>Collaborating Physician</TableColumn>
        <TableColumn>Action</TableColumn>
      </TableHeader>
      {itemsLoading ?
        <TableRow>
          <Loader width={200} height={200} />
        </TableRow>
        :
        npCoordinationItems.map((npCoordinationItem, idx) => (
          <TableRow key={`npCoordinationItem-${idx}`}>
            <TableColumn className="table-column">
              <ProviderCell
                providerData={npCoordinationItem.nursePractitioner}
                withLink={true}
              />
            </TableColumn>
            <TableColumn className="table-column">
              {convertStateCdToStateNm(npCoordinationItem.stateCd)}
            </TableColumn>
            <TableColumn className="table-column">
              <ProviderCell
                providerData={npCoordinationItem.supervisor}
                withLink={false}
              />
            </TableColumn>
            <TableColumn className="table-column">
              <EditModal state={npCoordinationItem.stateCd}
                physicianId={npCoordinationItem.nursePractitioner.id}
                supervisor={npCoordinationItem.supervisor}
              />
            </TableColumn>
          </TableRow>
        ))
      }
    </Table>
  );
};

export default NpCoordinationItemsTable;
